export default __webpack_public_path__ + "static/media/assembly_3.83c172c4.webp";